module.exports = __webpack_public_path__ + "static/media/sj.5c02688a.svg";